import BaseError from './Base'
import NotFoundError from './NotFound'

export default {
  BaseError,
  NotFoundError,
}
